import styled from "styled-components";
import { motion } from "framer-motion";

export const StyledAppAnimatePage = styled(motion.div)`
  height: 100%;
  width: 100%;
`;
